module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAYAAAARIY8tAAAACXBIWXMAAAsSAAALEgHS3X78AAABRklEQVRIibWV21HDMBBFTxj+QweoA0wFhA5SwM5gOnAJlJASzMwWkFRA6MBUgOkgrsB8SAY/9HDGyf3y7Grv1T68WrVtyzVxc1V24HbOIVXdAAWQOVMF7EWkTMWuUiVS1RJ4Cbg/ga2InELx0RKp6i5CDvAElDGOYAaqaoDvWHAPjyJS+RyxDDYzyQG2IUdMwJwhEMTVxzQmsD+Dx1t/SIypqh6xkxLDj4iYkDNVohxoIv6GSIOTAiJSY5v97nEfgCw0nh1i/0GGXQ9F96e6lQFQichJVe+AHVCKyHG2gKrmLnANfGHXQT06Y7CD8OBMr77dNBFwt/zwXObA/7QY/CtkIjIQcClXwL0neA4abF/qzjBucrGAHGxJ3/qGsUC+gLzDYGz/BFzTlty+w7o3bYMMzAXIJ1z9J7MCni8kUHcfySdzKX4BdBRuau5vFqgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 56